function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.9 22.8H12.1V12.5C12.1 5.6 17.44 0 24 0c6.56 0 11.9 5.6 11.9 12.5v10.3zm-19.8-4.2h15.8v-6.1c0-4.58-3.54-8.3-7.9-8.3s-7.9 3.72-7.9 8.3v6.1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37 48H11c-1.65 0-3-1.41-3-3.15v-23.1a3.08 3.08 0 013-3.15h26c1.65 0 3 1.41 3 3.15v23.1A3.08 3.08 0 0137 48zm-25-4.2h24v-21H12v21z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.9 38.55h-3.8c-.57 0-1.01-.55-.92-1.14l.82-5.16-.27-1.14c-.37-1.56.75-3.06 2.27-3.06s2.64 1.5 2.27 3.06L26 32.25l.82 5.16c.1.6-.35 1.14-.92 1.14z"
})));